var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.LogOut,{scopedSlots:_vm._u([{key:"activator",fn:function({ logout }){return [_c('button',{staticClass:"user-alert__action user-alert__action-logout",on:{"click":logout}},[_vm._v(" Log out ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }